import mutations from './mutations';
import state from './state';
import * as actions from './actions';

export default {
  namespaced: true,
  mutations,
  actions,
  state,
};
